import API from '..'

export const ProjectsAPI = {
  getAll: () => {
    return API.post(`/projects.get`)
  },
}
